export default {
      id: "requestFailed-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#requestFailed-usage",
      toString: function () {
        return this.url;
      }
    }